import { useMediaQuery } from '@mui/material';
import { Suspense, useEffect, useState, lazy } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import routes from '../../Utils/Constants/routes';
import { useAuthContext } from '../../Context/authContext';
import { useTheme } from '@emotion/react';
import { TABLET_BREAKPOINT } from '../../Utils/Constants/constant';
import { useAppContext } from '../../Context/appContext';
import { getApplicationsByApplicantId, getAxiosInstance, getAllQueryByApplicantId } from '../../Utils/apiServices';
import { PrivateRouter, PublicRouter } from '../../Utils/Helpers/applicationHelper';
import KenLoader from '../../Components/KenLoader';
import StudentInterviewModule from '../studentInterviewModule';
import InterviewBookslotTab from '../studentInterviewModule/Components/InterviewBookslotTab/index.jsx'

// Icons
import home from '../../Assets/Icons/home.png';
import homeII from '../../Assets/Icons/home II.png';

// Lazy loaded components
const AppLayout = lazy(() => import('../../Components/AppLayout'));
const Login = lazy(() => import('../Auth/Login'));
const SignUp = lazy(() => import('../Auth/SignUp'));
const Interview = lazy(() => import('../InterviewModule/index'));
const Scoresheet = lazy(() => import('../../Containers/InterviewModule/ScoreSheet/index')); // ✅ add scoresheet
const ConfirmingEmail = lazy(() => import('../Auth/ConfirmingEmail'));

export default function MainLayout() {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down(TABLET_BREAKPOINT));
  const location = useLocation();

  const {
    state: { isLoading = false },
  } = useAppContext();

  const {
    state: { user },
  } = useAuthContext();

  const [publishedCount, setPublishedCount] = useState(0);
  const [sideNavMenu, setSideNavMenu] = useState([]);

  // Fetch published queries count for notifications
  // const fetchQueries = async () => {
  //   try {
  //     if (!user?.applicantId) return;
  //     const response = await getAllQueryByApplicantId(user.applicantId);

  //     let count = 0;
  //     response.forEach(item => {
  //       const comments = item.comments;
  //       if (Array.isArray(comments)) {
  //         const published = comments.filter(
  //           comment =>
  //             comment?.createdByName !== 'Application Portal Integration User' &&
  //             comment?.isPublished === true
  //         );
  //         count += published.length;
  //       }
  //     });

  //     setPublishedCount(count);
  //   } catch (error) {
  //     console.error('Error fetching queries:', error);
  //   }
  // };

  // useEffect(() => {
  //   fetchQueries();
  // }, [user?.applicantId]);

  // useEffect(() => {
  //   if (location.pathname === routes.queryView) {
  //     fetchQueries();
  //   }
  // }, [location.pathname]);

  getAxiosInstance();

  useEffect(() => {
    // Always include Interview link at start
    const tempData = [
      {
        icon: home,
        mobileIcon: homeII,
        label: 'Interview',
        link: routes.interview,
        callback: '',
      },
    ];


    setSideNavMenu(tempData);
  }, [isMobileScreen, user?.applicantId]);

  return (
    <>
      {isLoading && <KenLoader />}
      <Suspense fallback={<KenLoader />}>
        <Routes>
          {/* Catch all unmatched routes */}
          <Route
            path="*"
            element={<Navigate to={routes.loginPage} />}
          />
          {/* Public Routes */}
          <Route
            path={routes.loginPage}
            element={
              <PublicRouter>
                <Login />
              </PublicRouter>
            }
          />
          <Route
            path={routes.register}
            element={
              <PublicRouter>
                <SignUp />
              </PublicRouter>
            }
          />
          <Route
            path={routes.confirmEmail}
            element={
              <PublicRouter>
                <ConfirmingEmail />
              </PublicRouter>
            }
          />

          {/* Private Routes inside AppLayout */}
          <Route
            path="app"
            element={<AppLayout sideNavMenu={sideNavMenu} isMobileScreen={isMobileScreen} />}
          >
            <Route
              path={routes.interview}
              element={
                // Uncomment PrivateRouter if you want authentication check here
                <PrivateRouter>
                  <Interview />
                </PrivateRouter>
              }
            />
            <Route
              path={routes.scoresheet}   // ✅ new scoresheet route
              element={
                <PrivateRouter>
                  <Scoresheet />
                </PrivateRouter>
              }
            />
            <Route
              path={routes.studentInterviewTab}   // ✅ new scoresheet route
              element={
                <PrivateRouter>
                  <StudentInterviewModule />
                </PrivateRouter>
              }
            />
             <Route
              path={routes.interviewBookslotTab}
              element={
                <PrivateRouter>
                  <InterviewBookslotTab/>
                </PrivateRouter>
              }
            />
          </Route>
        </Routes>
      </Suspense>
    </>
  );
}
